import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Radio } from "@material-ui/core";
import React from "react";
import { grey300, secondary } from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "60vw",
  },
  row: {
    paddingBottom: theme.spacing(3),
  },
  inputLabel: {
    marginLeft: theme.spacing(1),
  },
  buttonRow: {
    "& button": {
      margin: `0 ${theme.spacing(1)}px`,
    },
  },
  datepicker: {
    border: `solid 1px ${grey300}`,
    height: theme.spacing(4),
    width: 170,
    cursor: "pointer",
    textTransform: "capitalize",

    "& .MuiGrid-root": {
      height: "100%",
      padding: `0 ${theme.spacing(1)}px`,

      "& svg": {
        color: secondary,
      },
    },
  },
  secondColumn: {
    paddingLeft: theme.spacing(1),
  },
  groupContainer: {
    marginBottom: theme.spacing(2),
  },
  fieldRowSpacing: {
    paddingBottom: theme.spacing(2),
  },
  inputTopLabel: {
    marginBottom: theme.spacing(1),
  },
}));

export const CustomRadio = withStyles({
  root: {
    color: secondary,
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&$checked": {
      color: secondary,

      "&:hover": { backgroundColor: "transparent" },
    },
  },
  checked: {},
})((props) => <Radio {...props} />);

export default useStyles;
